import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import "rxjs/add/operator/catch";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private injector: Injector;

  private get authService(): AuthService {
    return this.injector.get(AuthService);
  }

  constructor(injector: Injector) {
    this.injector = injector;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.applyCredentials(req))
      .catch(e => {
        const errorObservable = Observable.throw(e);
        if (e instanceof HttpErrorResponse) {
          const statusCode = (e as HttpErrorResponse).status;
          if (statusCode === 401 || statusCode === 403) {
            return errorObservable.do(null, () => this.authService.logout());
          }
        }
        return errorObservable;
      });
  }

  private applyCredentials(req: HttpRequest<any>): HttpRequest<any> {
    if (req.headers.get('Authorization') != null) {
      return req;
    }

    const token = this.authService.getAuthToken();
    if (token == null || token.accessToken == null) {
      return req;
    }

    const authHeaderValue = 'JWT ' + token.accessToken;
    return req.clone({headers: req.headers.set('Authorization', authHeaderValue)});
  }
}




// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/http/auth.interceptor.ts